import { render, staticRenderFns } from "./Payroll-statement.vue?vue&type=template&id=672268d8&scoped=true&"
import script from "./Payroll-statement.vue?vue&type=script&lang=js&"
export * from "./Payroll-statement.vue?vue&type=script&lang=js&"
import style0 from "./Payroll-statement.vue?vue&type=style&index=0&id=672268d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672268d8",
  null
  
)

export default component.exports